import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../plugins/feathersClient';

class Staff extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'staff';

  // Define default properties here
  static instanceDefaults() {
    return {
      firstName: '',
      middleName: '',
      lastName: '',
      dateOfBirth: null,
      gender: null,
      citizenship: null,
      married: null,
      countryId: null,
      city: null,
      phone: null,
      languageLevel: null,
      timezoneOffset: null
    };
  }
}
const servicePath = 'staff';
const servicePlugin = makeServicePlugin({
  Model: Staff,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
